/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Wizard_TitleInputs */

const cs_import_wizard_title = /** @type {(inputs: Import_Wizard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Průvodce importem`)
};

const en_import_wizard_title = /** @type {(inputs: Import_Wizard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import wizard`)
};

/**
* | output |
* | --- |
* | "Import wizard" |
*
* @param {Import_Wizard_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_wizard_title = /** @type {((inputs?: Import_Wizard_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Wizard_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_wizard_title(inputs)
	return cs_import_wizard_title(inputs)
});